import { v4 as uuidv4 } from 'uuid';
import { SubstanceGrid } from '.';
import SubstanceGridPluginSettings from './SubstanceGridPluginSettings';

export const SubstanceTab = (): ITab => {
    return {
        id: uuidv4(),
        title: 'МНН',
        view: {
            content:    SubstanceGridPluginSettings 
                        ? <SubstanceGrid gridId={uuidv4()} plugin={SubstanceGridPluginSettings} />
                        : <p> Справочник не настроен </p>
        }
    }
}

export default SubstanceTab